import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const Services = () => {
  const { ref, isVisible } = useScrollAnimation()

  const services = [
    {
      icon: 'fas fa-user-tie',
      number: '01',
      title: 'Permanent Recruitment',
      description: 'We source, screen, and secure high-quality candidates for long-term roles—focusing on both capability and cultural fit to ensure lasting success.',
      category: 'employers'
    },
    {
      icon: 'fas fa-clock',
      number: '02',
      title: 'Temporary & Contract Staffing',
      description: 'Need flexibility? We provide reliable temporary and contract staff to keep your business moving, whether it\'s short-term cover or project-based support.',
      category: 'employers'
    },
    {
      icon: 'fas fa-search',
      number: '03',
      title: 'Executive & Specialist Search',
      description: 'For critical or hard-to-fill roles, we take a targeted, proactive approach—identifying top-tier talent that isn\'t always actively looking.',
      category: 'employers'
    },
    {
      icon: 'fas fa-map-location-dot',
      number: '04',
      title: 'Talent Mapping & Workforce Planning',
      description: 'We help you stay ahead by identifying future talent pipelines and providing insights into the New Zealand labour market.',
      category: 'employers'
    },
    {
      icon: 'fas fa-briefcase',
      number: '05',
      title: 'Career Placement',
      description: 'We connect you with opportunities that align with your skills, goals, and values—not just any job, but the right one.',
      category: 'candidates'
    },
    {
      icon: 'fas fa-file-alt',
      number: '06',
      title: 'CV & Interview Support',
      description: 'From refining your CV to preparing for interviews, we help you present your best self with confidence.',
      category: 'candidates'
    },
    {
      icon: 'fas fa-calendar-alt',
      number: '07',
      title: 'Temporary & Contract Opportunities',
      description: 'Looking for flexibility or variety? We offer a range of short-term and contract roles across multiple industries.',
      category: 'candidates'
    },
    {
      icon: 'fas fa-user-graduate',
      number: '08',
      title: 'Ongoing Career Support',
      description: 'We build long-term relationships, offering guidance and opportunities throughout your career journey.',
      category: 'candidates'
    }
  ]

  return (
    <section id="services" className="services section" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Our Services
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            Comprehensive Recruitment <span className="gradient-text">Solutions</span>
          </h2>
          <p className={`section-subtext ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Tailored services for both employers seeking top talent and candidates finding their perfect career opportunity.
          </p>
        </div>

        {/* For Candidates Section */}
        <div className="service-category">
          <h3 className={`category-title ${isVisible ? 'animate-fadeInUp' : ''}`}>
            For <span className="gradient-text">Candidates</span>
          </h3>
          <div className="services-grid">
            {services.filter(s => s.category === 'candidates').map((service, index) => (
              <div 
                key={index} 
                className={`service-card card card-accent-top ${isVisible ? 'animate-fadeInUp' : ''}`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="service-header">
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description}</p>
                <button
                  className="btn-link"
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Learn more <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* For Employers Section */}
        <div className="service-category">
          <h3 className={`category-title ${isVisible ? 'animate-fadeInUp' : ''}`}>
            For <span className="gradient-text">Employers</span>
          </h3>
          <div className="services-grid">
            {services.filter(s => s.category === 'employers').map((service, index) => (
              <div 
                key={index} 
                className={`service-card card card-accent-top ${isVisible ? 'animate-fadeInUp' : ''}`}
                style={{ animationDelay: `${(index + 4) * 100}ms` }}
              >
                <div className="service-header">
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description}</p>
                <button
                  className="btn-link"
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Learn more <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
